import Slideout from "slideout";
import Vue from "vue/dist/vue.esm.js";

var HttpClient = function () {
  this.get = function (aUrl, aCallback) {
    var anHttpRequest = new XMLHttpRequest();
    anHttpRequest.onreadystatechange = function () {
      if (anHttpRequest.readyState == 4 && anHttpRequest.status == 200)
        aCallback(anHttpRequest.responseText);
    };

    anHttpRequest.open("GET", aUrl, true);
    anHttpRequest.send(null);
  };
};

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

let padding;

if (viewportWidth > 767) {
  padding = 420;
} else {
  padding = 300;
}

if (document.getElementById("panel")) {
  const slideout = new Slideout({
    panel: document.getElementById("panel"),
    menu: document.getElementById("menu"),
    padding: padding,
    tolerance: 70,
  });

  document.querySelector(".menu-button").addEventListener("click", function () {
    slideout.toggle();
  });

  document.querySelector(".pal-live").addEventListener("click", function () {
    slideout.close();
  });

  function close(e) {
    e.preventDefault();
    slideout.close();
  }

  slideout
    .on("beforeopen", function () {
      this.panel.classList.add("panel-open");
    })
    .on("open", function () {
      this.panel.addEventListener("click", close);
    })
    .on("beforeclose", function () {
      this.panel.classList.remove("panel-open");
      this.panel.removeEventListener("click", close);
    });
}

document.querySelector(".close-modal").addEventListener("click", function () {
  document.querySelector(".guest-box").innerHTML = "";
  document.querySelector(".modal").classList.remove("is-active");
  document.querySelector("html").classList.remove("is-clipped");
});

document
  .querySelector(".modal-background")
  .addEventListener("click", function () {
    document.querySelector(".guest-box").innerHTML = "";
    document.querySelector(".modal").classList.remove("is-active");
    document.querySelector("html").classList.remove("is-clipped");
  });

function applyModalToGuests(document) {
  document.querySelectorAll(".guest").forEach((guest) => {
    guest.addEventListener("click", function () {
      console.log("clicked");
      let id = this.getAttribute("data-id");
      let client = new HttpClient();
      client.get(`/guests/${id}/`, function (response) {
        document.querySelector(".guest-box").innerHTML = response;
        document.querySelector("html").classList.add("is-clipped");
        document.querySelector(".modal").classList.add("is-active");
      });
    });
  });
}

function applyModalToTexts(document) {
  document.querySelectorAll(".biblio-text").forEach((guest) => {
    guest.addEventListener("click", function () {
      let id = this.getAttribute("data-id");
      let client = new HttpClient();
      client.get(`/tunisi/bibliografia/${id}/`, function (response) {
        document.querySelector(".guest-box").innerHTML = response;
        document.querySelector("html").classList.add("is-clipped");
        document.querySelector(".modal").classList.add("is-active");
      });
    });
  });
}

function applyModalToAudios(document) {
  document.querySelectorAll(".biblio-audio").forEach((guest) => {
    guest.addEventListener("click", function () {
      let id = this.getAttribute("data-id");
      let client = new HttpClient();
      client.get(`/tunisi/bibliografia/audio/${id}/`, function (response) {
        document.querySelector(".guest-box").innerHTML = response;
        document.querySelector("html").classList.add("is-clipped");
        document.querySelector(".modal").classList.add("is-active");
      });
    });
  });
}

applyModalToGuests(document);
applyModalToTexts(document);
applyModalToAudios(document);

if (document.getElementById("events")) {
  const events = new Vue({
    el: "#events",
    data() {
      return { day: null };
    },
    methods: {
      setDay(day) {
        if (day == this.day) {
          this.day = null;
        } else {
          this.day = day;
        }
      },
    },
    mounted() {
      applyModalToGuests(document);
    },
    watch: {
      day() {
        this.$nextTick(() => {
          applyModalToGuests(document);
        });
      },
    },
  });
}

if (document.getElementById("radio")) {
  const radio = new Vue({
    el: "#radio",
    data() {
      return {
        audio: null,
        playing: true,
        headHtml: "",
        footHtml: "",
        sponsorHtml: "",
      };
    },
    methods: {
      playPause() {
        if (this.playing) {
          this.playing = false;
          this.audio.pause();
          if (isSafari) {
            location.reload();
          }
          return;
        }
        this.audio.load();
        this.playing = true;
        this.audio.play();
      },
      fetch() {
        let client = new HttpClient();
        console.log("updating...");
        client.get("/live-radio.json", (response) => {
          const sections = JSON.parse(response);

          if (sections.head != this.headHtml) {
            this.headHtml = sections.head;
            this.footHtml = sections.foot;
            this.sponsorHtml = sections.sponsor;
            this.$nextTick(() => {
              applyModalToGuests(document);
            });
          }
        });
      },
    },
    mounted() {
      this.audio = this.$el.querySelectorAll("audio")[0];
      this.fetch();
      this.audio.play().catch((e) => {
        console.log(e);
        this.audio.pause();
        this.playing = false;
      });

      this.interval = setInterval(() => this.fetch(), 120000); // 2 min
    },
  });
}

if (document.getElementById("sg")) {
  const sgCollapse = new Vue({
    el: "#sg",
    data() {
      return {
        expanded: [],
      };
    },
    methods: {
      expand(id) {
        if (this.expanded.includes(id)) {
          const index = this.expanded.indexOf(id);
          this.expanded.splice(index, 1);
        } else {
          this.expanded.push(id);
        }
      },
    },
  });
}
